import { StateCreator } from "zustand";

import { UsersAPI } from "api/users";
import { UserForm } from "models/admin/admin";
import { RootState } from "store";

export interface AdminSlice {
  editUser: {
    isSaving: boolean;
  };

  savingUser: (isSaving: boolean) => void;
  editExternalUser: (user: UserForm) => void;
}

export const createAdminSlice: StateCreator<
  RootState,
  [["zustand/devtools", never]],
  [],
  AdminSlice
> = (set, get) => ({
  editUser: {
    isSaving: false
  },
  customers: [],

  savingUser: (isSaving) =>
    set(
      ({ admin }) => ({
        admin: {
          ...admin,
          editUser: {
            ...admin.editUser,
            isSaving
          }
        }
      }),
      false,
      "admin/SAVING_USER"
    ),

  editExternalUser: async (user) => {
    set({}, false, "admin/EDIT_EXTERNAL_USER");
    try {
      get().admin.savingUser(true);
      await UsersAPI.editExternalUser(user);
    } catch (error) {
      // Error already handled by errorHandlingPlugin
    } finally {
      get().admin.savingUser(false);
    }
  }
});
